import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/Domain/components/Shared/Select/Select';
import { UI_LANGUAGES } from '@/Domain/enum/SupportLanguage.enum';

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const currentLanguage = i18n.language || 'en';

  const handleChangeLanguage = (lng: string) => {
    localStorage.setItem('__qc_i18nextLng', lng);
    i18n.changeLanguage(lng);
  };

  return (
    <Select value={currentLanguage} onValueChange={handleChangeLanguage}>
      <SelectTrigger className="min-w-[120px] h-[39px]" data-testid="language-switch">
        <SelectValue placeholder="Select language" />
      </SelectTrigger>
      <SelectContent>
        {UI_LANGUAGES.map(({ code, label }) => (
          <SelectItem key={code} value={code} lang={code} data-testid={`language-option-${code}`}>
            {label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
